import { ArrowLeft, Loader2, Mail, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

type MagicLinkSentProps = {
  email: string;
  isResending: boolean;
  onResend: () => void;
  onBack: () => void;
};

export function MagicLinkSent({ email, isResending, onResend, onBack }: MagicLinkSentProps) {
  return (
    <div className="flex flex-col items-center">
      <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-gold-accent/20">
        <Mail className="h-8 w-8 text-gold-accent" />
      </div>

      <h2 className="mb-2 text-center font-semibold text-3xl text-gray-900 tracking-tight sm:text-4xl">
        Check Your Email
      </h2>
      <p className="mb-2 text-center text-base text-gray-500 sm:text-lg">We sent a magic link to</p>
      <p className="mb-6 text-center font-medium text-base text-gray-900 sm:text-lg">{email}</p>

      <div className="w-full max-w-md space-y-4">
        <div className="rounded-lg border border-gold-accent/30 bg-gold-accent/10 p-4">
          <p className="text-center text-gray-700 text-sm">
            Click the link in your email to create your account and continue to Aideco. The link
            expires in 15 minutes.
          </p>
        </div>

        <div className="space-y-3 pt-2">
          <Button
            className="w-full border-gray-200 bg-white font-medium text-gray-700 transition-all hover:border-gold-accent/50 hover:bg-gray-50"
            disabled={isResending}
            onClick={onResend}
            size="lg"
            type="button"
            variant="outline"
          >
            {isResending ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Sending...
              </>
            ) : (
              <>
                <RefreshCw className="mr-2 h-4 w-4" />
                Resend magic link
              </>
            )}
          </Button>

          <button
            className="flex w-full items-center justify-center gap-2 py-2 text-center text-gray-500 text-sm transition-colors hover:text-gray-700"
            onClick={onBack}
            type="button"
          >
            <ArrowLeft className="h-4 w-4" />
            Use a different email
          </button>
        </div>

        <p className="pt-4 text-center text-gray-400 text-xs">
          Didn't receive the email? Check your spam folder or try resending.
        </p>
      </div>
    </div>
  );
}
